<template>
  <div class="file-item-container">
    <div class="file-bg" @click="viewFile">
        <div class="file-content">
            <div class="file-icon">
                <img src="../../assets/imgs/dcu_file.png" alt="" width="16" height="16">
            </div>
            <div class="file-name-link"><span>{{filename}}</span></div>
        </div>
        <div class="file-view"><span>查看</span></div>
    </div>
  </div>
</template>

<script>

export default {
  uuid: "00000000-0000-0000-0000-000000100004",
  components: {},
  props: [
    'datamodel',
    'inList',
  ],
  data() {
    return {
      
    }
  },
  computed: {
    title() {
      return this.datamodel.zhlabel
    },
    filelocation() {
      return this.datamodel.value.filelocation
    },
    filename() {
      return this.datamodel.value.filename
    }
  },
  methods: {
    viewFile() {
        window.open(this.datamodel.value.filelocation)
    }
  },
  created() {},
  mounted() {

  }
}
</script>
<style lang="scss" scoped>
.file-item-container {
    // height: 100px;
    margin: 16px 0;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    flex: 1;
    .file-bg {
        // margin: 0 31px;
        background-color: #F1F3F4;
        display: flex;
        height: 36px;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px;
        position: relative;
        .file-content {
            flex: 1;
            display: flex;
            align-items: center;
            .file-icon {
                display: flex;
                align-items: center;
            }
        }
        .file-name-link {
            margin-left: 16px;
            flex: 1;
            overflow: hidden;
            color: #999;
            overflow: hidden;
            word-wrap: break-word;
            word-break: keep-all;
            // max-width: calc(100% - 60px);

            span {
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
              overflow: hidden;
            }
        }
        .file-view {
            position: absolute;
            right: 10px;
            top: 10px;
            z-index: 1;
            width: 50px;
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: 0.04em;
            text-align: right;
            color: #56BDF9;

        }
    }

}

</style>
